import apiClient, { setTokens, clearTokens } from './apiClient';

export async function login(email, password) {
  const { data } = await apiClient.post('/auth/login', { email, password });
  if (!data.mfaRequired) setTokens(data);
  return data;
}

export async function verifyMfa(mfaChallengeToken, code) {
  const { data } = await apiClient.post('/auth/mfa/verify', { mfaChallengeToken, code });
  if (!data.mfaRequired) setTokens(data);
  return data;
}

export async function logout() {
  const refreshToken = sessionStorage.getItem('mcg_refresh_token');
  try {
    if (refreshToken) await apiClient.post('/auth/logout', { refreshToken });
  } finally {
    clearTokens();
  }
}

export async function fetchCurrentUser() {
  const { data } = await apiClient.get('/auth/me');
  return data;
}

export async function enrollMfa() {
  const { data } = await apiClient.post('/auth/mfa/enroll');
  return data; // { secret, otpAuthUri }
}

export async function confirmMfa(code) {
  await apiClient.post('/auth/mfa/confirm', { code });
}

export async function changeOwnPassword(currentPassword, newPassword) {
  await apiClient.post('/auth/change-password', { currentPassword, newPassword });
}
